export enum PlatformEnvironment {
    Demo = 'Demo',
    Development = 'Development',
    Feature = 'Feature',
    Production = 'Production',
    Quality = 'Quality',
    Test = 'Test',
}
